import React from 'react';
import { motion } from 'framer-motion';
import accountingImg from '../images/photos/accounting.gif'; // replace with your actual image path

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

const Industries_AccountingFinance = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: '60vh',
      padding: '20px',
      fontFamily:
        "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    {/* Page Heading */}
    <h1
      style={{
        fontSize: '34px',
        marginBottom: '24px',
        textAlign: 'center',
        color: '#1e293b'
      }}
    >
      Accounting & Finance
    </h1>

    <section
      style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      {/* Left: Image */}
      <div style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}>
        <img
          src={accountingImg}
          alt="Accounting and Finance"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
          }}
        />
      </div>

      {/* Right: Content */}
      <div style={{ flex: '1 1 300px' }}>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Building Trust Through Financial Excellence. At Zyntro Software Solutions Pvt. Ltd., we
          specialize in providing comprehensive accounting and financial services that help
          businesses succeed and grow. With a deep understanding of the financial landscape, our
          expert team offers personalized solutions including bookkeeping, tax preparation,
          financial reporting, business consulting, and more. We focus on delivering accurate,
          transparent, and timely financial management tailored to meet your business’s unique
          needs.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Whether you’re a startup, small business, or a large enterprise, we understand the
          critical role financial clarity plays in driving success. Our mission is to simplify the
          complexities of accounting and finance, ensuring you make well-informed decisions that
          align with your business goals. From streamlining your financial processes to offering
          strategic advice, we’re here to ensure that every number works in your favor.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          At Zyntro Software Solutions Pvt. Ltd., your financial well-being is our top priority.
          Trust us to handle the numbers while you focus on scaling and growing your business.
        </p>
      </div>
    </section>
  </motion.div>
);

export default Industries_AccountingFinance;
